import "../css/header.scss";
import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { CartContext } from "./CartContext";
import { FaRegHeart, FaShoppingCart, FaTimes } from "react-icons/fa";

function Header() {
  const { cartItems, favorites } = useContext(CartContext) || { cartItems: [], favorites: [] };
  const cartCount = cartItems?.length || 0;
  const favoritesCount = favorites?.length || 0;
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchQuery = params.get("search");
    if (location.pathname === '/shop' && searchQuery) {
      setSearchTerm(searchQuery);
    } else if (location.pathname !== '/shop') {
      setSearchTerm("");
    }
  }, [location.pathname, location.search]);

  const handleSearch = (e) => {
    if (e.key === "Enter" && searchTerm.trim()) {
      navigate(`/shop?search=${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  const clearSearch = () => {
    setSearchTerm("");
    if (location.pathname === '/shop' && new URLSearchParams(location.search).get("search")) {
      navigate('/shop');
    }
  };

  return (
    <header className="site-header">
      <div className="header-top">
        <div className="container">
          <div className="header-top-right">
            <div className="top-links">
              <Link to="/contact">CONTACT US</Link>
              <Link to="/faqs">FAQS</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="header-middle">
        <div className="container">
          <div className="logo">
            <Link to="/">DZCP HiFi</Link>
          </div>

          <div className="search-bar" style={{ position: 'relative' }}>
            <input
              type="text"
              placeholder="Search for products"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleSearch}
              style={{ paddingRight: searchTerm ? '35px' : '15px' }}
            />
            {searchTerm && (
              <FaTimes 
                onClick={clearSearch}
                style={{ 
                  position: 'absolute', 
                  right: '15px', 
                  top: '50%', 
                  transform: 'translateY(-50%)', 
                  cursor: 'pointer',
                  color: '#999',
                  fontSize: '14px'
                }} 
              />
            )}
          </div>

          <div className="header-actions">
            <div className="action-icons">
              <Link to="/wishlist" className="action-icon">
                <div className="icon-wrapper">
                  <FaRegHeart />
                  <span className="badge">{favoritesCount}</span>
                </div>
              </Link>

              <Link to="/cartpage" className="action-icon cart-icon">
                <div className="icon-wrapper">
                  <FaShoppingCart />
                  <span className="badge">{cartCount}</span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="header-bottom">
        <div className="container">
          <nav className="main-nav">
            <ul>
              <li>
                <Link to="/">HOME</Link>
              </li>
              <li>
                <Link to="/shop">SHOP</Link>
              </li>

              <li>
                <Link to="/about">ABOUT US</Link>
              </li>
              <li>
                <Link to="/contact">CONTACT US</Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
